// Piezas comunes de las descargas (Excel/PDF): logo, cabecera gris de la
// federación y utilidades de color/descarga.
export const ROJO = 'FFE8321E';
export const GRIS = 'FFEFEFEF';
export const LILA = 'FFD6D0E5';
const LOGO_URL = `${process.env.PUBLIC_URL || ''}/logofmds.png`;
export const LOGO_RATIO = 1299 / 1772;

export const rgb = (argb) => [1, 3, 5].map((i) => parseInt(argb.slice(i + 1, i + 3), 16));

export const cargarLogo = async () => {
  try {
    const res = await fetch(LOGO_URL);
    if (!res.ok) return null;
    return await res.blob();
  } catch {
    return null;
  }
};

export const blobADataUrl = (blob) =>
  new Promise((resolve) => {
    const lector = new FileReader();
    lector.onload = () => resolve(lector.result);
    lector.readAsDataURL(blob);
  });

export const descargarBlob = (blob, nombre) => {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = nombre;
  a.click();
  URL.revokeObjectURL(a.href);
};

// Filas 1-6 de la hoja: banda gris con los tres textos centrados y el logo a
// la izquierda. `numColumnas` es el ancho de la banda.
export async function cabeceraExcel(libro, hoja, temporada, numColumnas) {
  for (let r = 1; r <= 6; r += 1) {
    hoja.getRow(r).height = r === 1 || r === 6 ? 14 : 24;
    for (let c = 1; c <= numColumnas; c += 1) {
      hoja.getCell(r, c).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: GRIS } };
    }
  }
  [
    [2, 'Federación Madrileña de Deportes para Sordos', false],
    [3, 'LIGA DE BÁDMINTON', true],
    [4, `TEMPORADA ${temporada.replace('-', ' - ')}`, true],
  ].forEach(([fila, texto, negrita]) => {
    hoja.mergeCells(fila, 1, fila, numColumnas);
    const celda = hoja.getCell(fila, 1);
    celda.value = texto;
    celda.font = { name: 'Arial', size: 10, bold: negrita };
    celda.alignment = { horizontal: 'center', vertical: 'middle' };
  });
  const logo = await cargarLogo();
  if (logo) {
    const id = libro.addImage({ buffer: await logo.arrayBuffer(), extension: 'png' });
    hoja.addImage(id, { tl: { col: 0.1, row: 1.1 }, ext: { width: 80 * LOGO_RATIO, height: 80 }, editAs: 'oneCell' });
  }
}

// Cabecera del PDF; devuelve la `y` donde puede empezar el contenido.
export async function cabeceraPDF(doc, temporada) {
  const ancho = doc.internal.pageSize.getWidth();
  doc.setFillColor(...rgb(GRIS));
  doc.rect(10, 8, ancho - 20, 34, 'F');
  const logo = await cargarLogo();
  if (logo) doc.addImage(await blobADataUrl(logo), 'PNG', 14, 10, 24 * LOGO_RATIO, 24);
  doc.setFont('helvetica', 'normal').setFontSize(10);
  doc.text('Federación Madrileña de Deportes para Sordos', ancho / 2, 18, { align: 'center' });
  doc.setFont('helvetica', 'bold').setFontSize(11);
  doc.text('LIGA DE BÁDMINTON', ancho / 2, 26, { align: 'center' });
  doc.text(`TEMPORADA ${temporada.replace('-', ' - ')}`, ancho / 2, 34, { align: 'center' });
  return 48;
}
